const MUAS = new Map([
    ["UASE0011", "Company Code already exists. Please try a new one"],
    ["UASE0060", "Company Name already exists. Please try a new one"],
])
export default MUAS